/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ModerationSummary = zod
	.object({
		total_cases: zod.number().describe('Total cases in range'),
		violations: zod.number().describe('Total violations in range')
	})
	.describe('Moderation summary totals');

export type ModerationSummary = zod.input<typeof ModerationSummary>;
export type ModerationSummaryOutput = zod.output<typeof ModerationSummary>;
